export default __webpack_public_path__ + "static/media/1335.a9ed5bfe.png";